import script from "./Indicator.vue?vue&type=script&lang=ts&setup=true"
export * from "./Indicator.vue?vue&type=script&lang=ts&setup=true"

import "./Indicator.vue?vue&type=style&index=0&id=4d82f074&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4d82f074"]])

export default __exports__